module.exports = __webpack_public_path__ + "img/middle-2.807f3b38.png";